import { atom, PrimitiveAtom } from 'jotai'

import { currentEnv } from '@/env/vars.ts'
import { queryClient } from '@/QueryClient'
import { store } from '@/store'
import { IQuotas } from '@/types/gigiChat/Quotas'
import { GET } from '@/utils/fetch'
import { pca } from '@/utils/MSAL'

export const quotasAtom: PrimitiveAtom<IQuotas | null> = atom<IQuotas | null>(null)
export const showQuotasDrawerAtom = atom(false)

export const toggleQuotasDrawer = () => {
    store.set(showQuotasDrawerAtom, !store.get(showQuotasDrawerAtom))
}

export const getQuotas = async () => {
    const accounts = pca.getAllAccounts()
    const res = await queryClient.fetchQuery({
        queryKey: ['quotas', accounts[0].username],
        queryFn: ({ queryKey }) =>
            GET<IQuotas>(
                currentEnv.features.isEnabled('gigiCore')
                    ? `${currentEnv.coreChatUrl}/quotas?user-email=${queryKey[1]}`
                    : `${currentEnv.utilityUrl}/quota?user-email=${queryKey[1]}`,
            ),
    })

    if (res) {
        store.set(quotasAtom, res)
    }
}
